(() => {
  const initMasivoLanding = (root = document) => {
    const landing = root.querySelector(
      '[data-masivo-landing]:not([data-masivo-initialized])'
    );

    if (!landing) return;

    landing.setAttribute('data-masivo-initialized', 'true');

    const sticky = landing.querySelector('[data-masivo-sticky]');
    const buttons = document.querySelectorAll('[data-masivo-scroll-buy]');

    const purchaseTarget =
      document.querySelector('.product-form__buttons') ||
      document.querySelector('product-form') ||
      document.querySelector('form[action*="/cart/add"]');

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        if (!purchaseTarget) return;

        purchaseTarget.scrollIntoView({
          behavior: window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth',
          block: 'center'
        });

        const primaryButton =
          purchaseTarget.querySelector('button[type="submit"]');

        window.setTimeout(() => {
          primaryButton?.focus({ preventScroll: true });
        }, 650);
      });
    });

    if (sticky && purchaseTarget && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          sticky.classList.toggle('is-hidden', entry.isIntersecting);
        },
        {
          threshold: 0.22
        }
      );

      observer.observe(purchaseTarget);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    initMasivoLanding(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initMasivoLanding(event.target);
  });
})();